/* istanbul ignore file */
/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

const CONSTANTS = {
    CONTENT_TYPES: {
        AUDIO_STEM: {id: 8, name: 'Audio Stem'},
        CLIP: {id: 7, name: 'Clip'},
        EPISODIC_RADIO_SPOT: {id: 1, name: 'Episodic Radio Spot'},
        GENERIC_RADIO_SPOT: {id: 2, name: 'Generic Radio Spot'},
        INTERVIEW: {id: 6, name: 'Interview'},
        SONG: {id: 5, name: 'Song'},
        SPOT_REEL: {id: 3, name: 'Spot Reel'},
        THEME_SONG: {id: 4, name: 'Theme Song'}
    },

    toArray: function(constant) {
        return Object.keys(this[constant])
            .map(k => this[constant][k])
            .sort((a, b) => a.name.localeCompare(b.name));
    }
};

CONSTANTS.CONTENT_TYPE_MAP = Object.keys(CONSTANTS.CONTENT_TYPES).reduce((r, sctName) => {
    let type = CONSTANTS.CONTENT_TYPES[sctName];
    r[type.id.toString()] = type;
    return r;
}, {});

export {
    CONSTANTS as AUDIO_CT_TYPES
};
